var map = {
	"./F.png": "JbsU",
	"./M.png": "vhgj",
	"./boy.png": "sSD0",
	"./edit.png": "LFqr",
	"./gril.png": "It9r"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Vj3i";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clans ^\.\/.*\.png$
// module id = Vj3i
// module chunks = 1